import { createFileRoute } from '@tanstack/react-router';
import { DlqPage } from '../../../operacoes/dlq/dlq-page.tsx';

export const Route = createFileRoute('/operacoes/dlq')({
  component: DlqPage,
});
